import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences')({
  component: Outlet,
});
